import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ANNUAL_FLEXIBLE_KEY, CMR_COVER, COMMERCIAL_BOND_COVER, COMPUTER_BREAKDOWN_COVER, CoverageAmountEnum, DIRECTORS_OFFICERS_COVER, EMPLOYERS_LIABILITY, EMPLOYMENT_PRACTICES_COVER, EMPLOYMENT_PRACTICES_EXCESS_LEVEL, EXCESS_LEVEL, FIDELITY_CRIME, GOODS_IN_TRANSIT, GidInsuranceBundleAll, GidInsuranceBundleListOnly, MONEY_ASSAULT_COVER, PACKAGE_COVER, PROFESSIONAL_INDEMNITY, PROPERTY_COVER_TYPE_LIST, PROVIDER_SOURCE, PUBLIC_LIABILITY, TEMPORARY_COVER_STATUTORY_LIMIT_KEY, UKCountryList, formatCurrency, gitBusinessActivityCourier, gitBusinessActivityRemovals, gitBusinessActivityVehicleTransportation, gitBusinessActivityVehicleTransportationAndRemovals, truelyValueMap } from '@jove-frontend/uikit';
import { has, isArray, isBoolean, isNull, isUndefined } from 'lodash';
export var handleServerCoverageListItemData = function handleServerCoverageListItemData(item, config) {
  if (!item) return {};
  var cover_slug = item.cover_slug,
      limit_per_occurrence = item.limit_per_occurrence,
      el_disease_each_employee = item.el_disease_each_employee,
      el_disease_policy_limit = item.el_disease_policy_limit,
      coverage_amount_type = item.coverage_amount_type,
      amount = item.amount,
      statutory = item.statutory,
      additional_insured = item.additional_insured,
      waiver_of_subrogation = item.waiver_of_subrogation,
      organization_subsidiary = item.organization_subsidiary,
      applicable_companies = item.applicable_companies;

  var tempItem = _objectSpread(_objectSpread({}, item), {}, {
    cover: cover_slug,
    coverSlug: cover_slug,
    perOccurrence: limit_per_occurrence,
    diseaseEachEmployee: el_disease_each_employee,
    diseasePolicyLimit: el_disease_policy_limit,
    additionalInsured: additional_insured,
    waiverOfSubrogation: waiver_of_subrogation
  }); // Statutory limit


  if (coverage_amount_type === CoverageAmountEnum.STATUTORY_LIMIT && !amount) {
    tempItem.amount = TEMPORARY_COVER_STATUTORY_LIMIT_KEY;
  } // Boolean: Per statute, additional_insured, waiver_of_subrogation


  if (isBoolean(statutory)) {
    tempItem.statutory = statutory ? truelyValueMap.yes.value : truelyValueMap.no.value;
  }

  if (isBoolean(additional_insured)) {
    tempItem.additionalInsured = tempItem.additional_insured = additional_insured ? truelyValueMap.yes.value : truelyValueMap.no.value;
  }

  if (isBoolean(waiver_of_subrogation)) {
    tempItem.waiverOfSubrogation = tempItem.waiver_of_subrogation = waiver_of_subrogation ? truelyValueMap.yes.value : truelyValueMap.no.value;
  } // Special field


  tempItem.organization_subsidiary = organization_subsidiary || [];
  tempItem.applicable_companies = applicable_companies || [];
  return tempItem;
};
export var handleServerCoverageListData = function handleServerCoverageListData(list, config) {
  return (list || []).map(function (item) {
    return handleServerCoverageListItemData(item, config);
  });
};
export var modifyQuoteCoverDisplayText = function modifyQuoteCoverDisplayText(coverKey, amount, currency, config) {
  if (amount === 0) {
    return 'I don’t need this cover';
  } else {
    if ((config === null || config === void 0 ? void 0 : config.quoteInsurance) === PROVIDER_SOURCE().ACCELERANT_GIT.value && coverKey === CMR_COVER) {
      return 'Included';
    } else {
      return formatCurrency({
        amount: amount,
        currency: currency
      });
    }
  }
};
export var sortTheCoveragesOrder = function sortTheCoveragesOrder(list, config) {
  var orderList = [GOODS_IN_TRANSIT, PROFESSIONAL_INDEMNITY, EXCESS_LEVEL, FIDELITY_CRIME, PUBLIC_LIABILITY, EMPLOYERS_LIABILITY, DIRECTORS_OFFICERS_COVER, EMPLOYMENT_PRACTICES_COVER, EMPLOYMENT_PRACTICES_EXCESS_LEVEL, COMMERCIAL_BOND_COVER, MONEY_ASSAULT_COVER, PACKAGE_COVER, COMPUTER_BREAKDOWN_COVER];
  var orderMap = {};
  orderList.forEach(function (item, index) {
    orderMap[item] = index;
  });
  return (list || []).sort(function (v1, v2) {
    var item1 = orderMap[v1[(config === null || config === void 0 ? void 0 : config.orderKey) || 'key']];
    var item2 = orderMap[v2[(config === null || config === void 0 ? void 0 : config.orderKey) || 'key']];
    if (item1 === undefined) return 1;
    if (item2 === undefined) return -1;
    return item1 - item2;
  });
};
export var getInsurancCoverageWhetherDisplayMap = function getInsurancCoverageWhetherDisplayMap(data) {
  var providerCode = data.providerCode,
      insuranceBundle = data.insuranceBundle,
      businessActivity = data.businessActivity,
      policyType = data.policyType;
  var pi = ![PROVIDER_SOURCE().ACCELERANT_GIT.value, PROVIDER_SOURCE().GREATEAMERICAN.value].includes(providerCode);
  var pl = !([PROVIDER_SOURCE().ACCELERANT_GIT.value].includes(providerCode) && insuranceBundle === GidInsuranceBundleListOnly || [PROVIDER_SOURCE().GREATEAMERICAN.value].includes(providerCode));
  var cmr = [PROVIDER_SOURCE().ACCELERANT_GIT.value].includes(providerCode) && [gitBusinessActivityCourier, gitBusinessActivityRemovals, gitBusinessActivityVehicleTransportation, gitBusinessActivityVehicleTransportationAndRemovals].includes(businessActivity);
  var el = Boolean([PROVIDER_SOURCE().ACCELERANT.value].includes(providerCode) || [PROVIDER_SOURCE().ACCELERANT_GIT.value].includes(providerCode) && insuranceBundle === GidInsuranceBundleAll || [PROVIDER_SOURCE().CHUBB.value].includes(providerCode) && policyType === ANNUAL_FLEXIBLE_KEY || [PROVIDER_SOURCE().RECRUITMENT.value].includes(providerCode));
  var exl = Boolean([PROVIDER_SOURCE().RECRUITMENT.value].includes(providerCode) || [PROVIDER_SOURCE().ACCELERANT.value].includes(providerCode));
  var git = [PROVIDER_SOURCE().ACCELERANT_GIT.value].includes(providerCode);
  return {
    pi: pi,
    pl: pl,
    cmr: cmr,
    el: el,
    exl: exl,
    git: git
  };
};
export var handleCoversSpeacialFieldInfo = function handleCoversSpeacialFieldInfo(covers, config) {
  var _config$coverageConfi;

  if (judgeWhetherShowCMRRequireSelectOptions(config) && !!(config !== null && config !== void 0 && config.coverageConfiguration) && (config === null || config === void 0 ? void 0 : (_config$coverageConfi = config.coverageConfiguration) === null || _config$coverageConfi === void 0 ? void 0 : _config$coverageConfi.requireInEU) === false && has(covers, CMR_COVER)) {
    covers[CMR_COVER] = 0;
  }

  if ([PROVIDER_SOURCE().ACCELERANT.value, PROVIDER_SOURCE().RECRUITMENT.value].includes(config === null || config === void 0 ? void 0 : config.providerCode)) {
    var propertyCoverValue = covers[PROPERTY_COVER_TYPE_LIST];

    if (!isUndefined(propertyCoverValue) && !isNull(propertyCoverValue) && !isArray(propertyCoverValue)) {
      covers[PROPERTY_COVER_TYPE_LIST] = [];
    }
  }

  return covers;
};
export var judgeWhetherShowCMRRequireSelectOptions = function judgeWhetherShowCMRRequireSelectOptions(config) {
  return [PROVIDER_SOURCE().ACCELERANT_GIT.value].includes(config === null || config === void 0 ? void 0 : config.providerCode) && UKCountryList.includes(config === null || config === void 0 ? void 0 : config.country);
};
export var judgeWhetherDisplayPropertyBuildingsSumInsured = function judgeWhetherDisplayPropertyBuildingsSumInsured(covers) {
  return isArray(covers === null || covers === void 0 ? void 0 : covers[PROPERTY_COVER_TYPE_LIST]) && covers[PROPERTY_COVER_TYPE_LIST].includes('buildings');
};
export var judgeWhetherDisplayPropertyBusinessInterruption = function judgeWhetherDisplayPropertyBusinessInterruption(covers) {
  return isArray(covers === null || covers === void 0 ? void 0 : covers[PROPERTY_COVER_TYPE_LIST]) && covers[PROPERTY_COVER_TYPE_LIST].includes('business-interruption');
};
export var judgeWhetherDisplayPropertyOfficeContentAndComputerEquipment = function judgeWhetherDisplayPropertyOfficeContentAndComputerEquipment(covers) {
  return isArray(covers === null || covers === void 0 ? void 0 : covers[PROPERTY_COVER_TYPE_LIST]) && (covers[PROPERTY_COVER_TYPE_LIST].includes('contents') || covers[PROPERTY_COVER_TYPE_LIST].includes('computers'));
};